export const PERSONAL_SHOPPER_LIST = "PERSONAL_SHOPPER_LIST";
export const PERSONAL_SHOPPER_LIST_SUCCESS = "PERSONAL_SHOPPER_LIST_SUCCESS";
export const PERSONAL_SHOPPER_LIST_FAIL = "PERSONAL_SHOPPER_LIST_FAIL";

export const PERSONAL_SHOPPER_LIST_2 = "PERSONAL_SHOPPER_LIST_2";
export const PERSONAL_SHOPPER_LIST_SUCCESS_2 = "PERSONAL_SHOPPER_LIST_SUCCESS_2";
export const PERSONAL_SHOPPER_LIST_FAIL_2 = "PERSONAL_SHOPPER_LIST_FAIL_2";

export const THREAD_USER = "THREAD_USER";
export const THREAD_USER_SUCCESS = "THREAD_USER_SUCCESS";
export const THREAD_USER_FAIL = "THREAD_USER_FAIL";

export const THREAD_CHAT = "THREAD_CHAT";
export const THREAD_CHAT_SUCCESS = "THREAD_CHAT_SUCCESS";
export const THREAD_CHAT_SUCCESS_FAIL = "THREAD_CHAT_SUCCESS_FAIL";

export const PERSONAL_SHOPPER_ITEMS_LIST = "PERSONAL_SHOPPER_ITEMS_LIST";
export const PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS = "PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS";
export const PERSONAL_SHOPPER_ITEMS_LIST_FAIL = "PERSONAL_SHOPPER_ITEMS_LIST_FAIL";

export const PERSONAL_SHOPPER_DROP_DOWN_LIST = "PERSONAL_SHOPPER_DROP_DOWN_LIST";
export const PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS = "PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS";
export const PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL = "PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL";

